import { MarketFeeModeEnum } from '@talos/kyoko';

export const DEALER_FEE_MODE_OPTIONS: MarketFeeModeEnum[] = [
  MarketFeeModeEnum.SpecificCurrency,
  MarketFeeModeEnum.QuoteCurrency,
  MarketFeeModeEnum.ReceiveCurrency,
  MarketFeeModeEnum.AmountCurrency,
];

export const EXCLUDE_EXCHANGE_FEES_GUIDE_TEXT =
  'When enabled, customer market data and fill prices exclude exchange fees. Exchange fees are not passed on to the customer.';

export const BOOLEAN_OPTIONS = [
  { label: 'Enabled', value: true },
  { label: 'Disabled', value: false },
];
